// @Utility
import { setStorage, getStorage } from "@utility/app/storage";

// Services
import { apiServices } from "@core/services/appService";

// Redux
// import { setStatusSpinner } from "@core/redux/actions/app/spinner";

const LOAD_SETTING = 'app/LOAD_SETTING';

function loadSetting(payload, setDataSettingError, _setDataSettingOffline, setProcessing) {
    return async (dispatch) => {
        try {
            const agentCode = process.env.REACT_APP_DEFAULT_AGENT_CODE
            const { code: statusCode, result } = await apiServices('timeout', 'get', `/general/setting-cache/${agentCode}`)

            // สั่งหยุด state loading ของหน้า
            if (typeof setProcessing === 'function') setProcessing(false)

            if ((statusCode === 200 || statusCode === 0) && result) {
                // success
                setDataSettingError?.(false)
                setStorage('setting', JSON.stringify(result))
                setStorage('agent_contact', JSON.stringify(result.agent_contact))
                setStorage('agent_logo', JSON.stringify(result.agent?.agent_image))
                dispatch({ type: LOAD_SETTING, payload: { items: result } })
                return
            }

            // ไม่ได้ 200/0 หรือ result ว่าง → ลองอ่านจาก cache
            const cached = getStorage('setting')
            const obj = cached ? JSON.parse(cached) : null
            if (obj) {
                dispatch({ type: LOAD_SETTING, payload: { items: obj } })
                setDataSettingError?.(false)
            } else {
                setDataSettingError?.(true)
                dispatch({ type: LOAD_SETTING, payload: { items: null } })
            }
        } catch (err) {
            // error จาก network/parse → fallback cache
            if (typeof setProcessing === 'function') setProcessing(false)
            try {
                const cached = getStorage('setting')
                const obj = cached ? JSON.parse(cached) : null
                if (obj) {
                    dispatch({ type: LOAD_SETTING, payload: { items: obj } })
                    setDataSettingError?.(false)
                } else {
                    setDataSettingError?.(true)
                    dispatch({ type: LOAD_SETTING, payload: { items: null } })
                }
            } catch {
                setDataSettingError?.(true)
                dispatch({ type: LOAD_SETTING, payload: { items: null } })
            }
        }
    }
}


export {
    LOAD_SETTING,
    loadSetting
}